import _slicedToArray from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import { Row, Col } from "reactstrap";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import Image from "../CustomImage";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Gallery = function Gallery(props) {
  var data = props.data;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      lightBoxOpen = _React$useState2[0],
      setLightBoxOpen = _React$useState2[1];

  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      activeImage = _React$useState4[0],
      setActiveImage = _React$useState4[1];

  var _onClick = function onClick(index) {
    setActiveImage(index);
    setLightBoxOpen(!lightBoxOpen);
  };

  var customStyles = {
    overlay: {
      zIndex: "1000"
    },
    bodyOpen: {
      position: "fixed"
    }
  };
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(Row, {
      className: props.rowClasses,
      children: data.map(function (item, index) {
        return /*#__PURE__*/_jsx(Col, {
          xs: props.xs,
          sm: props.sm,
          md: props.md,
          lg: props.lg,
          xl: props.xl,
          className: props.colClasses,
          children: /*#__PURE__*/_jsx(Image, {
            src: "".concat(item.img),
            width: 1350,
            height: 900,
            alt: item.alt,
            layout: "responsive",
            className: "img-fluid img-gallery",
            sizes: "(max-width:991px) 50vw, 240px",
            onClick: function onClick() {
              return _onClick(index);
            }
          }, index)
        }, index);
      })
    }), lightBoxOpen && /*#__PURE__*/_jsx(Lightbox, {
      mainSrc: "".concat(data[activeImage].img),
      nextSrc: "".concat(data[(activeImage + 1) % data.length].img),
      prevSrc: "".concat(data[(activeImage + data.length - 1) % data.length].img),
      onCloseRequest: function onCloseRequest() {
        return setLightBoxOpen(false);
      },
      imageCaption: data[activeImage].title,
      onMovePrevRequest: function onMovePrevRequest() {
        return setActiveImage((activeImage + data.length - 1) % data.length);
      },
      onMoveNextRequest: function onMoveNextRequest() {
        return setActiveImage((activeImage + 1) % data.length);
      },
      enableZoom: false,
      reactModalStyle: customStyles
    })]
  });
};

export default Gallery;